import BaseModel from '../core/BaseModel'
export default class VisitHistoryModel extends BaseModel {

    constructor() {
        super({
                name: "visit_history",
                tableName: 'visit_history',
                label: "Visit history"
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                }
            })
    }

}